import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, HelpCircle } from 'lucide-react';
import FaqAccordion from '../Faq/FaqAccordion';
import API from '../../utils/api';
import './FaqSection.css';

// Home page FAQs: the first 10 visible questions, in the order the admin arranged them. The rest live on /faq.
const FaqSection = () => {
    const [faqs, setFaqs] = useState([]);
    const [total, setTotal] = useState(0);

    useEffect(() => {
        let cancelled = false;
        API.get('/faqs', { params: { limit: 10 } })
            .then(res => {
                if (cancelled) return;
                setFaqs(res.data.faqs || []);
                setTotal(res.data.total || (res.data.faqs || []).length);
            })
            .catch(() => { if (!cancelled) setFaqs([]); });
        return () => { cancelled = true; };
    }, []);

    if (faqs.length === 0) return null;

    return (
        <section className="hfq" aria-labelledby="hfq-title">
            <div className="hfq__inner">
                <header className="hfq__heading">
                    <span className="hfq__kicker"><HelpCircle size={14} /> Quick answers</span>
                    <h2 id="hfq-title">Questions families often ask</h2>
                    <p>Everything you may want to know before you begin.</p>
                </header>

                <FaqAccordion faqs={faqs} defaultOpenFirst />

                <div className="hfq__more">
                    <Link to="/faq">{total > faqs.length ? `View all ${total} FAQs` : 'Open the FAQ page'} <ArrowRight size={16} /></Link>
                </div>
            </div>
        </section>
    );
};

export default FaqSection;
